import { useSelector } from 'react-redux';
import { useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { PATH_AUTH } from '@app/routes/paths';
import { selectIsAuthenticated } from '@app/modules/common';

// ----------------------------------------------------------------------

interface AuthGuardProps {
  children: ReactNode;
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

export { AuthGuard };
